import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Flex, Text } from '@chakra-ui/react'

import { PrimaryButton } from '@enechain/ecloud-designsystem'
import { FaUserRegular } from '@enechain/ecloud-icons'

import { OrganizationAdmin } from '~/components/authorize/OrganizationAdmin'
import { FallbackImage } from '~/components/parts/FallbackImage'
import { MemberRole } from '~/gen/proto/bff/v1/model_pb'
import { useLoginOrganization } from '~/hooks/useLoginOrganization'
import { useLoginUser } from '~/hooks/useLoginUser'
import { FilteredMembers } from '~/pages/Members/components/FilteredMembers'
import MembersTable from '~/pages/Members/components/MembersTable'
import { MemberPageHeader } from '~/pages/Members/components/layouts/Header'
import { useMembers } from '~/pages/Members/hooks/useMembers'

import { MemberInfomation } from './components/MemberInfomation'

export const Members: React.FC = () => {
  const organization = useLoginOrganization()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const onClickAddMember = (): void => {
    void navigate({
      to: '/members/create',
    })
  }
  const me = useLoginUser()
  const hasLicense = Object.keys(me.baseLicenseMap).length > 0
  const members = useMembers(me.organizationId)
  // The filter/CSV section is admin-only: members with the メンバー role
  // cannot see the organization's plans/roles.
  const isAdmin = me.role === MemberRole.ADMIN

  return (
    <MemberPageHeader>
      <Flex
        flexDirection="column"
        gap="3"
        maxWidth="1280px"
        margin="auto"
        padding="2"
      >
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center" gap="2">
            <FallbackImage
              width="40px"
              borderRadius="radiiMd"
              fallbackSrc="https://storage.googleapis.com/enec-eauth-prod-bucket/organization/default"
              src={organization.imageUrl}
            />
            <Text
              textStyle="headerLg"
              color="Text.highEmphasis"
              textAlign="left"
            >
              {organization.name}
            </Text>
          </Flex>
          <OrganizationAdmin>
            {hasLicense && (
              <PrimaryButton
                leftIcon={<FaUserRegular boxSize="24px" />}
                onClick={onClickAddMember}
              >
                {t('pages.members.action.inviteMember.button')}
              </PrimaryButton>
            )}
          </OrganizationAdmin>
        </Flex>
        <MemberInfomation />
        {isAdmin ? (
          <FilteredMembers members={members} />
        ) : (
          <MembersTable members={members} />
        )}
      </Flex>
    </MemberPageHeader>
  )
}
